var XPortal = XPortal || {};
XPortal.CustomEvents = (function () {
    const helpers = {

        /* PPS01 -product unit price calculation on fly */
        async PPS01_UpdateSOLUnitPriceForLine(context, action, next) {
            if (!context || !action) return warn('event to [update unit price for line] has been called incorrectly!!!', 1);
            if (!context.isOneOfFields(action, "no", "quantity", "variantcode") || !context.isForEntity("SalesOrderLine")) return;

            const before = XPortal.Store.GetModelByName(action.model).entity;
            const dBfrNo = getObjValueLCase(before, "no");
            const dBfrQt = getObjValueLCase(before, "quantity");
            const dBfrVc = getObjValueLCase(before, "variantcode");
            next(action);
            action.preventDefault = true;

            const curModel = XPortal.Store.GetModelByName(action.model);
            const dAftNo = getObjValueLCase(curModel.entity, "no");
            const dAftQt = getObjValueLCase(curModel.entity, "quantity");
            const lineId = getObjValueLCase(curModel.entity, "uniqueid");
            const variantcode = getObjValueLCase(curModel.entity, "variantcode");
            const uomCode = getObjValueLCase(curModel.entity, "unitofmeasurecode");

            if (dBfrNo == dAftNo && dBfrQt == dAftQt && dBfrVc == variantcode) return;
            if (!dAftNo || !dAftQt || isNaN(Number(dAftQt)) || Number(dAftQt) <= 0) return;

            const curEntityName = curModel.model.Alias.toLowerCase();
            const prtMName = XPortal.Store.GetParentModelName(action.model);
            const prtModel = XPortal.Store.GetModelByName(prtMName);
            const customerNo = getObjValueLCase(prtModel.entity, "selltocustomerno");
            const currencycode = getObjValueLCase(prtModel.entity, "currencycode");
            warn('start: erc03 updating line unitprice by rules:' + action.field.field + '', -1, { dAftNo, dAftQt });
            XPortal.Store.GetRelatedData({
                url: "/umbraco/surface/PPackage/CalcProdUnitPrice", request: {
                    uniqueid: lineId,
                    parentInfo: getParentInfo(action.model),
                    entityAlias: curEntityName,
                    nodeId: curModel.model.NodeId,
                    no: dAftNo,
                    quantity: dAftQt,
                    variantcode,
                    customerNo,
                    currencycode,
                    uomCode,
                    data: JSON.stringify(getSimpleProperties(curModel.entity))
                }
            }).then(function (response) {
                if (!response || response.State < 0) return;
                const curEntity = XPortal.Store.GetModelByName(action.model).entity;
                updateTotalsFor(prtMName, action.model, response);
                //dispatchIfDiff(action.model, curEntity, response, "Description", "ItemDescription");
                dispatchIfDiff(action.model, curEntity, response, "unitprice", "unitprice");
                dispatchIfDiff(action.model, curEntity, response, "lineamount", "AmountExclVAT");
                dispatchIfDiff(action.model, curEntity, response, "AmountIncludingVAT", "AmountInclVAT");
                dispatchIfDiff(action.model, curEntity, response, "VATProdPostingGroup", "VATProdPostingGroup");
                dispatchIfDiff(action.model, curEntity, response, "VATBusPostingGroup", "VATBusPostingGroup");
                dispatchIfDiff(action.model, curEntity, response, "VATPerc", "VATPercent");

                const uprice = getObjValue(response, "unitprice");
                const quantt = getObjValue(curEntity, "quantity");
                const ruprice = uprice == null || isNaN(uprice) ? 0 : uprice;
                const vstatus = uprice == null || isNaN(uprice) ? "UnitPriceInvalid" : "";
                const vmssg = vstatus ? "Unit Price is Invalid" : "";
                XPortal.Store.DispatchByName(action.model, "validationstatus", vstatus);
                XPortal.Store.DispatchByName(action.model, "validationmessage", vmssg);
            });
        },
        /* PPS05 - Get Support customer Info by No */        
        async SupportContract_GetСustomerInfoByNo() {            
            if (!context || !action || !context.RelatedData.Project) return warn('event to [update customer infor by no] has been called incorrectly!!!', 1);
            if (!context.isOneOfFields(action, "BillToCustomerNo") || !context.isForEntity("Project")) return;//BillToCustomerName

            const before = XPortal.Store.GetModelByName(action.model).entity;
            const dBfrCNo = getObjValueLCase(before, "BillToCustomerNo");
            next(action);
            action.preventDefault = true;

            const curModel = XPortal.Store.GetModelByName(action.model);            
            const dAftCNo = getObjValueLCase(curModel.entity, "BillToCustomerNo");

            if (dBfrCNo == dAftCNo) return;
            if (!dAftCNo) return;

            const xquery = context.getQuery("no", "=", dAftCNo);
            context.RelatedData.Customer(xquery).then(function (response) {
                const lookUpEntity = response.filter(itm => itm.no === dAftCNo);
                if (lookUpEntity.length > 1) warn('there are more then one result-> can\'t handle', 0, newProject, lookUpEntity);
                if (lookUpEntity.length < 1) return warn('there are no such customer', 0, newProject, lookUpEntity);

                const customer = lookUpEntity[0];
                const curEntity = XPortal.Store.GetModelByName(action.model).entity;
                dispatchIfDiff(action.model, curEntity, customer, "BillToCustomerName", "name");
                dispatchIfDiff(action.model, curEntity, customer, "CustomerContactName", "contact");
                dispatchIfDiff(action.model, curEntity, customer, "CustomerContactEmail", "");
                
            }, function (h, e, o) { });
        }
    };
    function updateTotalsFor(prtMName, crtMName, response) {
        const prtMContainer = XPortal.Store.GetModelByName(prtMName);
        window.clearTimeout(prtMContainer.ttlTimeout);
        prtMContainer.ttlTimeout = window.setTimeout(function () {
            const crtModel = XPortal.Store.GetModelByName(crtMName);
            const grdLines = mergeLines(crtModel.GetGridItems() || [], response.Lines || []);
            let tElxVat = 0;
            let tIclVat = 0;
            const tvat = [];
            grdLines.forEach(l => {
                const lev = Number(getObjValue(l, "LineAmount"));
                const liv = Number(getObjValue(l, "AmountIncludingVAT"));
                const lvp = Number(getObjValue(l, "VATPerc"));
                tElxVat = tElxVat + (isNaN(lev) || lev < 0 ? 0 : lev);
                tIclVat = tIclVat + (isNaN(liv) || liv < 0 ? 0 : liv);
                if (!isNaN(lvp) && lvp > 0)
                    if (tvat.find(x => x == lvp) == null) tvat.push(lvp);
            });
            const vat = tIclVat - tElxVat;
            XPortal.Store.DispatchByName(prtMName, "vat", String(vat), false);
            XPortal.Store.DispatchByName(prtMName, "AmountIncludingVAT", String(tIclVat), false);
            XPortal.Store.DispatchByName(prtMName, "Amount", String(tElxVat), false);
        }, 1000);
    };
    function mergeLines(grdLines, srvLines) {
        var processed = [];
        var result = [];
        grdLines.forEach(l => {
            const x = getLineFields(l);
            processed.push(x.uniqueId);
            result.push(x);
        });
        srvLines.forEach(l => {
            const lid = getObjValue(l, "uniqueid").toLowerCase();
            if (processed.find(x => x) == null) {
                processed.push(lid);
                result.push(l);
            };
        });
        return result;
    };
    function getLineFields(l) {
        return {
            uniqueId: getObjValue(l, "uniqueId"),
            CurrencyCode: getObjValue(l, "CurrencyCode"),
            DocumentNo: getObjValue(l, "DocumentNo"),
            Quantity: getObjValue(l, "Quantity"),
            UnitOfMeasureCode: getObjValue(l, "UnitOfMeasureCode"),
            VariantCode: getObjValue(l, "VariantCode"),
            VatBusPostingGroup: getObjValue(l, "VatBusPostingGroup"),
            VatProdPostingGroup: getObjValue(l, "VatProdPostingGroup"),
            UnitPrice: getObjValue(l, "UnitPrice"),
            LineAmount: getObjValue(l, "LineAmount"),
            VATPerc: getObjValue(l, "VATPerc"),
            AmountIncludingVAT: getObjValue(l, "AmountIncludingVAT")
        };
    }

    function dispatchIfDiff(modelName, curData, srcData, cFname, sFname) {
        var cval = getObjValue(curData, cFname);
        var sval = getObjValue(srcData, sFname);
        if (cval != sval) {
            XPortal.Store.DispatchByName(modelName, cFname, sval, false, true);
        }
    };
    function dispatchIfEmpty(modelName, curData, srcData, cFname, sFname) {
        var cval = getObjValue(curData, cFname);
        var sval = getObjValue(srcData, sFname);
        if (!cval || cval != "")
            XPortal.Store.DispatchByName(modelName, cFname, sval);
    };
    function getSimpleProperties(obj) {
        if (!obj) return obj;
        const r = {};
        for (var i in obj) {
            const v = obj[i];
            if (i == i.toLowerCase() && typeof (v) != "function" && i[0] != "_" && i.indexOf("field") == -1 && i.indexOf("defaults") == -1) {
                r[i] = obj[i];
            }
        }
        if (obj.Fields && obj.Fields.length) {
            r.Fields = [];
            obj.Fields.forEach(x => {
                r.Fields.push({ Name: x.Name, Type: x.Type, Data: x.StringValue });
            });
        }
        return r;
    };
    function getParentInfo(modelName) {
        const pmodelName = XPortal.Store.GetParentModelName(modelName);
        const pmodel = pmodelName ? XPortal.Store.GetModelByName(pmodelName) : null;
        if (!pmodel) return null;
        const parentUid = (XPortal.Template.GetObjPropValueByName(pmodel.entity || {}, "uniqueid") || "");
        if (!parentUid || !pmodel.model) return null;
        return pmodel.model.NodeId + "#|#" + parentUid;
    };
    function getObjValue(o, prname, dval) {
        const r = XPortal.Template.GetObjPropValueByName(o, prname);
        if (dval && !r) return dval;
        return r;
    };
    function getObjValueLCase(o, prname) {
        const v = XPortal.Template.GetObjPropValueByName(o, prname);
        return tLowerCase(v);
    };
    function tLowerCase(o, dv) {
        const so = o ? String(o).toLowerCase() : (dv || "").toLowerCase();
        return so;
    };
    function warn(msg, iscritical, ...args) {
        if (!console) return;
        const stack = [];// (new Error().stack || "").split("\n").slice(1).filter((x) => x.indexOf("portal.store.js") == -1 && x.indexOf("Object.event") == -1 && x.indexOf("Object.EnsureMid") == -1 && x.indexOf("warn (http") == -1);
        if (iscritical > 0) return console.error(msg, [...args, ...stack]);
        if (iscritical == 0) return console.warn(msg, [...args, ...stack]);
        return console.log(msg, [...args, ...stack]);
    };
    //register events in repository
    function waitFor(onAction, onFalse) { if (!onAction()) { setTimeout(function () { onFalse(onAction, onFalse); }, 100); } };
    waitFor(function () {
        if (XPortal["Events"] && XPortal["Events"]["helpers"]) {
            for (var i in helpers) XPortal.Events.helpers[i] = helpers[i];

            return true;
        } else return false;
    }, waitFor);
    //end of registration
    return helpers;
})();
